import { useCallback, useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import type { RecentGame } from '@/api/games';
import { useSubscription } from '@/modules/realTime/hooks';
import { useGetCommonStore } from '@/store';

export const useGamesFiltration = () => {
  const useCommonStore = useGetCommonStore();

  const {
    isAuthenticated,
    recentGamesIds,
    fetchRecentGames,
    updateRecentGames,
  } = useCommonStore(
    useShallow((state) => ({
      isAuthenticated: state.isAuthenticated,
      recentGamesIds: state.recentGamesIds,
      fetchRecentGames: state.fetchRecentGames,
      updateRecentGames: state.updateRecentGames,
    }))
  );

  const isMobileDevice = useCommonStore.use.isMobileDevice();
  const handleUpdateRecentGames = useCallback(
    (data: RecentGame) => {
      updateRecentGames(data);
    },
    [updateRecentGames]
  );

  useSubscription<RecentGame>('played_games', handleUpdateRecentGames);

  useEffect(() => {
    if (!(isAuthenticated && recentGamesIds.length)) return;

    fetchRecentGames(isMobileDevice);
  }, [isAuthenticated, recentGamesIds, isMobileDevice, fetchRecentGames]);
};
